var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersatileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0669 10.6313C19.0677 11.4007 18.9456 12.1653 18.7051 12.8962C18.1574 14.9227 16.9523 16.7099 15.279 17.9774H15.2771L9.5696 22.7592L3.33584 17.5419C1.65998 15.8504 0.25804 13.5584 0.129577 10.8949C0.0130258 8.49823 0.812101 6.14693 2.36483 4.31758C3.91756 2.48823 6.10777 1.3177 8.4915 1.04327C10.8752 0.768834 13.2741 1.41102 15.2019 2.83966C17.1298 4.2683 18.4423 6.3765 18.8734 8.73693C18.8835 8.79228 18.8786 8.84945 18.859 8.9022C18.9976 9.46817 19.0674 10.0488 19.067 10.6315L19.0669 10.6313Z",
    fill: "#02C27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62469 12.5941C11.6797 12.5941 13.3454 10.9284 13.3454 8.87335C13.3454 6.81846 11.6797 5.15259 9.62469 5.15259C7.5698 5.15259 5.90393 6.81833 5.90393 8.87335C5.90393 10.9282 7.56967 12.5941 9.62469 12.5941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersatileIcon);
export default __webpack_public_path__ + "static/media/versatile_icon.4917289c36c33ad99c984592ec3b04db.svg";
export { ForwardRef as ReactComponent };